"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceFieldsQueryGrid = exports.mapResultNode = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var DatasourceFieldsDisplayGrid_1 = require("./DatasourceFieldsDisplayGrid");
function mapResultNode(field, resultData) {
    var _a, _b, _c;
    return {
        id: 'id' in field ? field.id : '',
        name: field.name,
        description: field.description,
        descriptionInherited: field.descriptionInherited,
        dataType: 'dataType' in field ? field.dataType : null,
        datasourceId: (_b = (_a = resultData.publishedDatasources) === null || _a === void 0 ? void 0 : _a[0].vizportalUrlId) !== null && _b !== void 0 ? _b : '',
        fieldIcon: (0, FieldFunctions_1.iconForField)(field),
        sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null,
        dataQualityWarnings: field.__typename === 'ColumnField' ? (_c = field.columnsConnection) === null || _c === void 0 ? void 0 : _c.nodes.flatMap(function (t) { return t.dataQualityWarnings; }, []) : [],
    };
}
exports.mapResultNode = mapResultNode;
function DatasourceFieldsQueryGrid(props) {
    var publishedConnectionsLineageEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: queries_1.DatasourceFieldsByIdDocument, partialQueryVariables: { vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled }, selectConnectionListResult: function (r) { return r && r.publishedDatasources && r.publishedDatasources[0] && r.publishedDatasources[0].fieldsConnection; }, mapResultNode: mapResultNode, hackyUpdateNumber: props.hackyUpdateNumber }, function (_a) {
        var rowStore = _a.rowStore;
        return (react_1.default.createElement(DatasourceFieldsDisplayGrid_1.DatasourceFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.DatasourceFieldsQueryGrid = DatasourceFieldsQueryGrid;
//# sourceMappingURL=DatasourceFieldsQueryGrid.js.map